import '../DeepAnalysis.less';
import React from 'react';
import { CHECK_HIGH_PRIORITY_THRESHOLD, CHECK_MEDIUM_PRIORITY_THRESHOLD } from '../settings';

type Props = {
    severity: number;
};

export default function ImpactIndicator({ severity }: Props) {
    /**
     def get_impact_level(impact_score):
    if impact_score >= 7.0:
        return 'high'
    if impact_score >= 4.0 and impact_score < 7.0:
        return 'medium'
    return 'low'
     */
    let label;
    if (severity >= 7) {
        label = 'high';
    } else if (severity >= 4 && severity < 7) {
        label = 'medium';
    } else {
        label = 'low';
    }

    // if (severity < CHECK_MEDIUM_PRIORITY_THRESHOLD) {
    //     label = 'low';
    // } else if (severity < CHECK_HIGH_PRIORITY_THRESHOLD) {
    //     label = 'medium';
    // } else {
    //     label = 'high';
    // }

    return (
        <span className={`deep-analysis-impact-indicator ${label}`}>
            <span>{label}</span>
        </span>
    );
}
